import { useAppSelector } from "hooks/hook";
import AppSwitcher from "resbutler-ui/components/AppSwitcher";

const OmsAppSwitcher = () => {
  const user = useAppSelector((state: any) => state.root.user);
  return <AppSwitcher user={user} hostApp="pd" />;
};

export default OmsAppSwitcher;
